import { render, staticRenderFns } from "./configurationAfterPayment.vue?vue&type=template&id=62420bc6&scoped=true"
import script from "./configurationAfterPayment.vue?vue&type=script&lang=js"
export * from "./configurationAfterPayment.vue?vue&type=script&lang=js"
import style0 from "./configurationAfterPayment.vue?vue&type=style&index=0&id=62420bc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62420bc6",
  null
  
)

export default component.exports